import RestService from "./RestService";

export default class ServiceStatusCheckingService extends RestService {
  constructor() {
    super("/api/servicestatus");
  }
}
